export default [
  { to: 'sjukhus', title: 'Sjukhus' },
  { to: 'primarvard', title: 'Primärvård' },
  { to: 'tandvard', title: 'Tandvård' },
  { to: 'allmant', title: 'Allmänt' },
  { to: 'calculator', title: 'SOFA-kalkylator' },
  { to: 'arkiv', title: 'Arkiv' },
];
